import { Button, Styles } from "@/shared/coralreef";
import { useBootTranslation } from "./BootFailed";

export function ReloadRequired() {
  const { t } = useBootTranslation();
  return (
    <div
      data-testid="reload-required"
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 16,
        background: Styles.Colours.darkestBlue,
        color: Styles.Colours.textLight,
      }}
    >
      <div style={{ fontSize: "1.25rem" }}>
        {t("A newer version of the app opened a window. Reload to continue.")}
      </div>
      <Button
        type="button"
        content={t("Reload")}
        appearance="hollow"
        onClick={() => window.location.reload()}
      />
    </div>
  );
}
